export default Object.freeze({
  Nuevo: 1,
  Aprobado: 2,
  Objetado: 3,
  Cancelado: 4,
});
